import { useCallback } from "react";
import { useEffect, useState } from "react";

export const FilterDropdown = (props) => {
  const [options, setOptions] = useState([]);

  const valueChanged = useCallback((value) => {
    props.filter.value = value;

    props.setFicheData((prev) => {
      return { ...prev, filter: props.ficheData.filter };
    });
  }, []);

  useEffect(() => {
    if (props.filter.options) {
      const newoptions = [];

      props.filter.options.forEach((option, index) => {
        newoptions.push(
          <option
            value={
              props.filter?.values[index] ? props.filter.values[index] : option
            }
          >
            {option}
          </option>
        );
      });

      setOptions(newoptions);
    }
  }, [JSON.stringify(props.filter.options)]);

  return (
    <div
      className={`col-sm-${
        props.filter.gridWidth != 0 ? props.filter.gridWidth : 4
      }`}
    >
      <label>
        <strong>{props.filter.title}</strong>
      </label>
      <select
        class="c-input__field c-toggle-label"
        id="field_subject"
        onChange={(evt) => valueChanged(evt.target.value)}
      >
        <option value={""}>{props.filter.defaultValue}</option>
        {options}
      </select>
    </div>
  );
};
